export default "__VITE_ASSET__22b01248__"